import React from 'react';
import ExamPeriodSummaryDashboard from '../../modules/exam/ExamPeriodSummaryDashboard';

const ExamPeriodSummaryDashboardPage = () => {
    return (
        <div className="container-fluid">
            <ExamPeriodSummaryDashboard />
        </div>
    );
};

export default ExamPeriodSummaryDashboardPage;